<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <b-nav-item-dropdown
        right
        class="notification-list"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0">
            <img v-if="!isHeaven" src="@assets/images/logo-sm.png" alt="user-image" class="rounded-circle" />
            <img v-else src="@assets/img/heaven/logo-sm.svg" alt="user-image" class="rounded-circle" />
            <span class="pro-user-name ml-1">
              {{ user ? user.name : '' }}
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item @click="logout">
          <i class="fe-log-out mr-1"></i>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="/" class="logo text-center">
        <span class="logo-lg">
          <img v-if="!isHeaven" src="@assets/images/logo.png" alt height="35" />
          <img v-else src="@assets/img/heaven/logo.svg" alt height="35" />
        </span>
        <span class="logo-sm">
          <img v-if="!isHeaven" src="@assets/images/logo-sm.png" alt height="24" />
          <img  v-else src="@assets/img/heaven/logo.svg" alt height="24" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button class="button-menu-mobile" @click="toggleMenu">
          <i class="fe-menu"></i>
        </button>
      </li>
    </ul>
  </div>
  <!-- end Topbar -->
</template>

<script>
import { authComputed } from '@store/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    logout() {
      this.$store.dispatch('logoutRequest').catch(function (err) {})
    },
  },
}
</script>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
